﻿import React, { useState, useEffect } from 'react';
import { Entities } from '../models/enums';
import IcColumnComponent from './IcColumnComponent';
import IcInstrument from './IcInstrument';
import { BenchSheetColumn } from '../models/bench-sheet-column';
import { HplcColumnHeader } from '../models/hplc-column-header';
import { FieldUpdate } from '../models/field-update';
import { NewColumnEntryRequest } from '../models/new-column-entry-request';
import { CrudFunctions } from '../utilities/crud-functions';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import { ItemBasicInformation } from '../models/item-basic-information';
import AuditHistoryComponent from './AuditHistoryComponent';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import DataGrid, {
    Column,
    Paging,
    Button as ColumnButton,
    Toolbar,
    Item as ToolbarItem,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';

let key = 1;

export interface Props {
    benchSheetId?: string;
    isReadOnly: boolean;
}

export default function IcColumnsComponent(props: Props) {
    const [instrumentColumns, setInstrumentColumns] =
        useState<BenchSheetColumn[]>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [analysisDataDialogVisible, setAnalysisDataDialogVisible] =
        useState<boolean>(false);

    const [auditInformationDialogVisible, setAuditInformationDialogVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, [props.benchSheetId]);

    key++;

    return (
        <div className="pw-content">
            <div className="pw-content">
                <div className="lq-header pw-margin-top-05">
                    <div className="lq-header-title">Columns</div>
                    <div className="title-bar-spacer" />

                    <div className="save-toolbar">
                        <Button id="onAddColumnButton" text="" icon="plus" type="normal"
                            hint="add new column" disabled={props.isReadOnly}
                            height={'2.6em'}
                            onClick={onAddColumn} />
                    </div>
                </div>
            </div>

            {instrumentColumns &&
                <div>
                    {instrumentColumns.length > 0 &&
                        <div>
                            <IcColumnComponent id={1} readOnly={props.isReadOnly}
                                column={instrumentColumns[0] ? instrumentColumns[0] : undefined}
                                onCreateNewColumnEntry={onCreateNewColumnEntry}
                                onColumnValueChanged={columnValueChanged}
                                onColumnDeleted={columnDeleted} />
                        </div>
                    }
                    {instrumentColumns.length > 1 &&
                        <div>
                            <IcColumnComponent id={2} readOnly={props.isReadOnly}
                                column={instrumentColumns[1] ? instrumentColumns[1] : undefined}
                                onCreateNewColumnEntry={onCreateNewColumnEntry}
                                onColumnValueChanged={columnValueChanged}
                                onColumnDeleted={columnDeleted} />
                        </div>
                    }
                    {instrumentColumns.length > 2 &&
                        <div>
                            <IcColumnComponent id={3} readOnly={props.isReadOnly}
                                column={instrumentColumns[2] ? instrumentColumns[2] : undefined}
                                onCreateNewColumnEntry={onCreateNewColumnEntry}
                                onColumnValueChanged={columnValueChanged}
                                onColumnDeleted={columnDeleted} />
                        </div>
                    }
                    {instrumentColumns.length > 3 &&
                        <div>
                            <IcColumnComponent id={4} readOnly={props.isReadOnly}
                                column={instrumentColumns[3] ? instrumentColumns[3] : undefined}
                                onCreateNewColumnEntry={onCreateNewColumnEntry}
                                onColumnValueChanged={columnValueChanged}
                                onColumnDeleted={columnDeleted} />
                        </div>
                    }
                </div>
            }
        </div>
    );

    async function onAddColumn(e: any) {

        console.log("onAddColumn");
        console.log(e);
        console.log(instrumentColumns);


        // don't add more than 4 columns to the db (they can't display)
        if (instrumentColumns && instrumentColumns.length > 4)
            return;

        const column: BenchSheetColumn = {
            benchSheetId: props.benchSheetId
        }

        await insertColumn(column)
            .then((res) => {
                getBenchSheetColumns();
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Inserting Column");
            });
    }

    async function onCreateNewColumnEntry(id: number, columnHeader: HplcColumnHeader) {
        const request:  NewColumnEntryRequest = {
            benchSheetId: props.benchSheetId,
            columnHeaderId: columnHeader.columnHeaderId
        };

        await insertColumnEntry(request)
            .then((data) => {
                // NEED TO KNOW WHGICH COLUMN COMPONENT
                // this.icColumnInformationComponent1

                /* TODO?
                if (icColumnInformationComponent1 && icColumnInformationComponent1.current)
                    icColumnInformationComponent1.current.hideGcColumnSearchDialog();
                    */


            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Inserting Column Entry");
            });
    }

    function columnValueChanged(fieldUpdate: FieldUpdate) {
        if (!dataLoaded)
            return;

        if (instrumentColumns && fieldUpdate.routeId !== undefined) {
            let sequence = fieldUpdate.routeId - 1;
            let editedInstrumentColumns = [...instrumentColumns];

            if (sequence > -1 && editedInstrumentColumns[sequence]) {
                let matchingBenchSheetColumn = editedInstrumentColumns[sequence];

                if (matchingBenchSheetColumn) {
                    matchingBenchSheetColumn = { ...matchingBenchSheetColumn, [fieldUpdate.field]: fieldUpdate.value };

                    editedInstrumentColumns[sequence] = matchingBenchSheetColumn;

                    setInstrumentColumns(editedInstrumentColumns);
                    updateColumnField(fieldUpdate);
                }
            }
        }
    }

    async function columnDeleted(headerColumnId: string) {
        if (headerColumnId) {
            await deleteIcColumn(props.benchSheetId, headerColumnId)
                .then(() => {
                    getBenchSheetColumns();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Column");
                });
        }
    }

    async function getBenchSheetColumns() {
        await CrudFunctions.getData(`benchsheets/icbenchsheetcolumns/${props.benchSheetId}`)
            .then(data => {
                setInstrumentColumns(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Bench Sheet Columns");
            });
    }

    async function getAllData() {
        await Promise.all([
            getBenchSheetColumns(),
        ])
            .then(() => {
                setDataLoaded(true);
            });
    }

    //POST functions

    async function insertColumn(column: BenchSheetColumn) {
        return CrudFunctions.postData("benchsheets/iccolumnbase", column);
    }

    async function insertColumnEntry(request: NewColumnEntryRequest) {
        return CrudFunctions.postData("benchsheets/hplccolumnentry", request);
    }

    // PUT functions

    async function updateColumnField(fieldUpdate: FieldUpdate) {
        return CrudFunctions.putData("benchsheets/benchsheetcolumnfield", fieldUpdate);
    }

    // DELETE functions

    async function deleteIcColumn(benchSheetId: string, headerColumnId: string) {
        return CrudFunctions.deleteData(`benchsheets/iccolumn/${benchSheetId}/${headerColumnId}`);
    }

    /*
    function showBenchSheetInformationDialog() {
        if (benchSheet) {
            let itemBasicInitInformation: ItemBasicInformation = {
                rowPointer: benchSheetId,
                createTimestamp: benchSheet.createTimestamp,
                lastModifiedTimestamp: benchSheet.modifyTimestamp,
                createUser: benchSheet.createUser,
                modifyUser: benchSheet.modifyUser
            };

            setItemBasicInitInformation(itemBasicInitInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }
    */

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}

